import { useMemo } from 'react';
import { useQuery } from 'react-query';
import useAuth from './useAuth';

export default () => {
  const { id } = useAuth();
  const { data, isLoading, isSuccess } = useQuery(['GET', `/apis/v2/patient_profiles/${id}/providers`, {}], { suspense: true });

  const providers = useMemo(() => {
    if (data?.data) {
      return data?.data;
    }
    return [];
  }, [data]);

  return {
    providers,
    isLoading,
    isSuccess,
  };
};
